const zh = {
    "註冊karos遊戲賬號":"註冊karos遊戲賬號",
    "windows遊戲主程式":"windows遊戲主程式",
    "會員資料":"會員資料",
    "more":"more",
    "回報記錄":"回報記錄",
    "查看详情":"查看详情",
    "查看更多":"more",
    "官網首頁": "官網首頁",
    "最新消息": "最新消息",
    "綜合": "綜合",
    "公告": "公告",
    "活動": "活動",
    "更新": "更新",
    "职业定位":"职业定位",
    "遊戲資訊": "遊戲資訊",
    "遊戲地圖": "遊戲地圖",
    "遊戲指南": "遊戲指南",
    "遊戲视频": "遊戲视频",
    "社群": "社群",
    "圖片分享區": "圖片分享區",
    "攻略討論區": "攻略討論區",
    "玩家討論區": "玩家討論區",
    "客服中心": "客服中心",
    "1:1詢問": "1:1詢問",
    "會員條款": "會員條款",
    "下載專區": "下載專區",
    "游戲下載": "游戲下載",
    "商城": "商城",
    "儲值點數": "儲值點數",
    "購買元寶": "購買元寶",
    "購買記錄": "購買記錄",
    "儲值記錄": "儲值記錄",
    "會員註冊": "會員註冊",
    "查詢帳號": "查詢帳號",
    "查詢密碼": "查詢密碼",
    "登入": "登入",
    "登出": "登出",
    "我的資料": "我的資料",
    "密碼更改": "密碼更改",
    "我的點数：": "我的點数：",
    "購買P-point後": "購買P-point後",
    " 點": "點",
    "玩家必須先儲值點數，方可在 購買元寶 頁面購買RF Online的元寶": "玩家必須先儲值點數，方可在 購買元寶 頁面購買RF Online的元寶",
    "上一頁": "上一頁",
    "下一頁": "下一頁",
    "例行維護時間": "例行維護時間",
    "每週四": "每週四",
    "客服服務時間": "客服服務時間",
    "週一至週五": "週一至週五",
    "客服信箱": "客服信箱",
    "視頻": "視頻",
    "原畫": "原畫",
    "發文": "發文",
    "輸入關鍵字": "輸入關鍵字",
    "搜索": "搜索",
    "全文": "全文",
    "主題": "主題",
    "會員帳號": "會員帳號",
    "安裝/執行": "安裝/執行",
    "儲值/購買": "儲值/購買",
    "遊戲問題": "遊戲問題",
    "消費記錄": "消費記錄",
    "訂單編號": "訂單編號",
    "狀態": "狀態",
    "商品": "商品",
    "價格": "價格",
    "登錄日": "登錄日",
    "實名認證": "實名認證",
    "我的禮包": "我的禮包",
    "暱稱：": "暱稱：",
    "帳號：": "帳號：",
    "帳號": "帳號",
    "密碼": "密碼",
    "信箱：": "信箱：",
    "手機號碼：": "手機號碼：",
    "同意接受": "同意接受",
    "《會員服務條款》": "《會員服務條款》",
    "《個人隱私條款》": "《個人隱私條款》",
    "同意接受 Panggame 消息及廣告訊息": "同意接受 Panggame 消息及廣告訊息",
    "同意接受在panggame提供的活動抽獎 及遊戲服務同意通知相關sms訊息": "同意接受在panggame提供的活動抽獎 及遊戲服務同意通知相關sms訊息",
    "輸入新密碼": "輸入新密碼",
    "請確認密碼": "請確認密碼",
    "姓名": "姓名",
    "請輸入身份證號": "請輸入身份證號",
    "取消": "取消",
    "確認": "確認",
    "記住登入資訊": "記住登入資訊",
    "手機找回": "手機找回",
    "信箱找回": "信箱找回",
    "手機": "手機",
    "請輸入信箱": "請輸入信箱",
    "信箱格式有誤": "信箱格式有誤",
    "請輸入姓名": "請輸入姓名",
    "請輸入密碼": "請輸入密碼",
    "請輸入手機號": "請輸入手機號",
    "手機號碼不正確，請重新輸入": "手機號碼不正確，請重新輸入",
    "請輸入手機號碼": "請輸入手機號碼",
    "請輸入文章主題": "請輸入文章主題",
    "請輸入新的信箱地址": "請輸入新的信箱地址",
    "請輸入正確帳號": "請輸入正確帳號",
    "請輸入自訂帳號": "請輸入自訂帳號",
    "請輸入角色": "請輸入角色",
    "請輸入帳號": "請輸入帳號",
    "請輸入郵箱": "請輸入郵箱",
    "請輸入驗證碼": "請輸入驗證碼",
    "驗證碼為 6 位數字": "驗證碼為 6 位數字",
    "獲取驗證碼": "獲取驗證碼",
    "驗證碼": "驗證碼",
    "修改": "修改",
    "信箱註冊": "信箱註冊",
    "手機註冊": "手機註冊",
    "歡迎加入panggame!": "歡迎加入panggame!",
    "爲使用遊戲，請按照以下的格式進行註冊流程。": "爲使用遊戲，請按照以下的格式進行註冊流程。",
    "完成註冊，即刻獲得上市祝福禮包！": "完成註冊，即刻獲得上市祝福禮包！",
    "購買": "購買",
    "點數是什麼？": "點數是什麼？",
    "點數購買": "點數購買",
    "儲值點數時，請先確認金額後再購買": "儲值點數時，請先確認金額後再購買",
    "購買成功": "購買成功",
    "點数不足": "點数不足",
    "消耗點數：": "消耗點數：",
    "當前點數：": "當前點數：",
    "購買價格：": "購買價格：",
    "道具資訊：": "道具資訊：",
    "持有點數：": "持有點數：",
    "扣除後點數：": "扣除後點數：",
    "您正在購買元寶": "您正在購買元寶",
    "取消購買": "取消購買",
    "確認購買": "確認購買",
    "儲值點數：": "儲值點數：",
    "儲值後點數：": "儲值後點數：",
    "暱稱僅有一次修改機會": "暱稱僅有一次修改機會",
    "輸入新暱稱": "輸入新暱稱",
    "舊信箱地址：": "舊信箱地址：",
    "新信箱地址：": "新信箱地址：",
    "舊手機號碼：": "舊手機號碼：",
    "新手機號碼：": "新手機號碼：",
    "手機：": "手機：",
    "已處理":"已處理",
    "待處理":"待處理",
    "發送成功": "發送成功",
    "上載失敗": "上載失敗",
    "兩次輸入的密碼並不相符，請重新輸入": "兩次輸入的密碼並不相符，請重新輸入",
    "請勾選同意接受條款": "請勾選同意接受條款",
    "註冊成功": "註冊成功",
    "分類": "分類",
    "問題": "問題",
    "聊天": "聊天",
    "建議": "建議",
    "留言": "留言",
    "上留言": "上留言",
    "回復": "回復",
    "请输入关键字": "请输入关键字",
    "發佈辱罵,相同文章重覆發文,誹謗,謠言等違反營運政策的貼文時，可能會受到限制發文，若有違法情事發生，自行負擔法律相關責任. 最長100個字元": "發佈辱罵,相同文章重覆發文,誹謗,謠言等違反營運政策的貼文時，可能會受到限制發文，若有違法情事發生，自行負擔法律相關責任. 最長100個字元",
    "使用點數": "使用點數",
    "當前點數": "當前點數",
    "商品名": "商品名",
    "確認密碼": "確認密碼",
    "您的信箱地址": "您的信箱地址",
    "請輸入賬號": "請輸入賬號",
    "密碼長度最少為 8 字元": "密碼長度最少為 8 字元",
    "密碼不能有特殊字元": "密碼不能有特殊字元",
    "自訂賬號需為英文字母和數字的組合，且第一個字元必須為英文，英文及數字必須為半形": "自訂賬號需為英文字母和數字的組合，且第一個字元必須為英文，英文及數字必須為半形",
    "自訂賬號長度最多為 32 字元": "自訂賬號長度最多為 32 字元",
    "修改成功": "修改成功",
    "未查找到該賬號": "未查找到該賬號",
    "暫無數據": "暫無數據",
    "賬號第一位必須為英文字母，最多 32 個字元": "賬號第一位必須為英文字母，最多 32 個字元",
    "請輸入自訂賬號": "請輸入自訂賬號",
    "立即註冊": "立即註冊",
    "極速下載": "極速下載",
    "新手指南": "新手指南",
    "裝備技能": "裝備技能",
    "進階攻略": "進階攻略",
    "其他": "其他",
    "角色介绍": "角色介绍",
    "刪除": "刪除",
    "刪除文章": "刪除文章",
    "刪除留言": "刪除留言",
    "確定要刪除嗎？": "確定要刪除嗎？",
    "OnGate 账号:": "OnGate 账号:",
    "二次登录密码:": "二次登录密码:",
    "真实姓名:": "真实姓名:",
    "出生日期:": "出生日期:",
    "请输入OnGate 账号": "请输入OnGate 账号",
    "请输入游戏账号二次登录密码": "请输入游戏账号二次登录密码",
    "请输入真实姓名": "请输入真实姓名",
    "请输入出生日期": "请输入出生日期",
    "请输入密码": "请输入密码",
    "請選擇分類": "請選擇分類",
    "請輸入": "請輸入",
    "請輸入主題": "請輸入主題",
    "请输入手机号码接收验证码信息": "请输入手机号码接收验证码信息",
    "请输入邮箱接收验证码信息": "请输入邮箱接收验证码信息",
    "实名认证信息不对": "实名认证信息不对",
    "確認新密碼不一致": "確認新密碼不一致",
  }
  
  module.exports = zh
  